import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import { z } from 'zod';
import { EmptyState, PageHead } from '../../components/ui/common';
import { ChatsPage } from '../../features/B7/page';
import type { ChatFilter } from '../../features/B7/types';
import { useCan } from '../../lib/session';

/** Lane B7-web — "צ'אטים" (D-71). ?c=<conversationId>&f=all|groups|private|unread */
const Search = z.object({
  c: z.string().max(64).optional().catch(undefined),
  f: z.enum(['all', 'groups', 'private', 'unread']).optional().catch(undefined),
});

export const Route = createFileRoute('/_app/chats')({
  validateSearch: (s: Record<string, unknown>) => Search.parse(s),
  component: ChatsRoute,
});

function ChatsRoute() {
  const { c, f } = Route.useSearch();
  const navigate = useNavigate({ from: '/chats' });
  const can = useCan();
  const onSearch = useCallback(
    (next: { c?: string; f?: ChatFilter }) =>
      void navigate({ search: (s) => ({ ...s, c: next.c, f: next.f === 'all' ? undefined : (next.f ?? s.f) }) }),
    [navigate],
  );
  if (!can('chats.view'))
    return (
      <>
        <PageHead title="צ'אטים" />
        <EmptyState icon="shield" title="אין הרשאה" text="אין לך הרשאה לצפות בצ'אטים. מנהל/ת המערכת יכולים להוסיף אותה." />
      </>
    );
  return <ChatsPage c={c} f={f ?? 'all'} onSearch={onSearch} />;
}
